import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

// ==================== CONVERSATIONS ====================

export const createConversation = async (type, title, country, token) => {
  const { data } = await axios.post(
    `${API_URL}/ai/conversations`,
    { type, title, country },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const getConversations = async (type, token) => {
  const { data } = await axios.get(`${API_URL}/ai/conversations`, {
    params: { type },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const getConversation = async (conversationId, token) => {
  const { data } = await axios.get(
    `${API_URL}/ai/conversations/${conversationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const updateConversation = async (conversationId, updates, token) => {
  const { data } = await axios.put(
    `${API_URL}/ai/conversations/${conversationId}`,
    updates,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const deleteConversation = async (conversationId, token) => {
  const { data } = await axios.delete(
    `${API_URL}/ai/conversations/${conversationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

// ==================== MESSAGES ====================

export const sendMessage = async (conversationId, content, generateImage, token) => {
  const { data } = await axios.post(
    `${API_URL}/ai/conversations/${conversationId}/messages`,
    { content, generateImage },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

// ==================== LAWYER SERVICES ====================

export const requestAnonymousLawyer = async (conversationId, specialization, notes, token) => {
  const { data } = await axios.post(
    `${API_URL}/ai/conversations/${conversationId}/lawyer/anonymous`,
    { specialization, notes },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const requestPresencialLawyer = async (conversationId, specialization, location, notes, token) => {
  const { data } = await axios.post(
    `${API_URL}/ai/conversations/${conversationId}/lawyer/presencial`,
    { specialization, location, notes },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const selectPresencialLawyer = async (conversationId, lawyerId, notes, preferredDate, token) => {
  const { data } = await axios.post(
    `${API_URL}/ai/conversations/${conversationId}/lawyer/select`,
    { lawyerId, notes, preferredDate },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const uploadDocuments = async (conversationId, files, token) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("documents", file);
  });

  const { data } = await axios.post(
    `${API_URL}/ai/conversations/${conversationId}/documents`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return data;
};

// ==================== UTILITIES ====================

export const getCountries = async (token) => {
  const { data } = await axios.get(`${API_URL}/ai/countries`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};
